/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DistributionPlugin,
  DistributionPlugin$inboundSchema,
} from "./distributionplugin.js";

export type ListDistributionPluginsResult = {
  plugins: Array<DistributionPlugin>;
};

/** @internal */
export const ListDistributionPluginsResult$inboundSchema: z.ZodMiniType<
  ListDistributionPluginsResult,
  unknown
> = z.object({
  plugins: z.array(DistributionPlugin$inboundSchema),
});

export function listDistributionPluginsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListDistributionPluginsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListDistributionPluginsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListDistributionPluginsResult' from JSON`,
  );
}
